import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/EmployeeConfiguration";

export const getEmployeeAdOverrideGroup = async () => {
  const { data } = await axios.get(`${api_base_url}/EmployeeADOverrideGroup`);
  return data;
};
